module.exports = __webpack_public_path__ + "static/9-ea17bf22f33539b1d2cbc92a61e8f4d0.jpg";